import { apiInterceptor } from 'utils/apiInterceptor';
export async function CreateChannel(projectId, inputs) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/channels?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(inputs),
        }
    );
    return await response.json();
}
